import script from "./TrustBand.vue?vue&type=script&setup=true&lang=js"
export * from "./TrustBand.vue?vue&type=script&setup=true&lang=js"

import "./TrustBand.vue?vue&type=style&index=0&id=6c5489ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c5489ec"]])

export default __exports__